import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

/* ── Shared components ──────────────────────────────────────────────────── */
import Nav    from './components/Nav';
import Footer from './components/Footer';

/* ── Pages ──────────────────────────────────────────────────────────────── */
import Home        from './pages/Home';
import AIDBA       from './pages/AIDBA';
import AIArchitect from './pages/AIArchitect';
import AICISO      from './pages/AICISO';
import AICISOv2    from './pages/AICISOv2';
import AIQA        from './pages/AIQA';
import Pricing     from './pages/Pricing';
import About       from './pages/About';
import Contact     from './pages/Contact';
import Custom      from './pages/Custom';
import PrivacyPolicy  from './pages/PrivacyPolicy';
import PrivacyRevSecAIGuardian from './pages/PrivacyRevSecAIGuardian';
import TermsOfService from './pages/TermsOfService';
import Security       from './pages/Security';
import Blog         from './pages/Blog';
import BlogShadowAI from './pages/BlogShadowAI';
import BlogDataModernisation from './pages/BlogDataModernisation';
import BlogNISTAIRMF from './pages/BlogNISTAIRMF';
import BlogSecureDeveloperAI from './pages/BlogSecureDeveloperAI';
import BlogAISecurityGovernance from './pages/BlogAISecurityGovernance';
import BlogOracleToPostgreSQL from './pages/BlogOracleToPostgreSQL';


/* ══════════════════════════════════════════════════════════════════════════
   ROUTE MAP
   To add a new page:
   1. Create  src/pages/YourPage.jsx
   2. Import  it above
   3. Add     <Route path="/your-path" element={<YourPage/>} />  below
   ══════════════════════════════════════════════════════════════════════════ */
export default function App() {
  return (
    <BrowserRouter>
      <Nav />
      <main>
        <Routes>
          <Route path="/"             element={<Home/>}        />
          <Route path="/ai-dba"       element={<AIDBA/>}       />
          <Route path="/ai-architect" element={<AIArchitect/>} />
          <Route path="/ai-ciso"      element={<AICISOv2/>}    />
          <Route path="/ai-ciso-v1"   element={<AICISO/>}      />
          <Route path="/ai-ciso-v2"   element={<AICISOv2/>}    />
          <Route path="/ai-qa"        element={<AIQA/>}        />
          <Route path="/pricing"      element={<Pricing/>}     />
          <Route path="/about"        element={<About/>}       />
          <Route path="/contact"      element={<Contact/>}     />
          <Route path="/custom"       element={<Custom/>}      />
          <Route path="/privacy"  element={<PrivacyPolicy/>} />
          <Route path="/privacy/revsec-ai-guardian" element={<PrivacyRevSecAIGuardian/>} />
          <Route path="/terms"    element={<TermsOfService/>} />
          <Route path="/security" element={<Security/>} />
          <Route path="/blog"                                  element={<Blog/>} />
          <Route path="/blog/shadow-ai-enterprise-discovery"   element={<BlogShadowAI/>} />
          <Route path="/blog/data-modernisation-ai-roadmap" element={<BlogDataModernisation/>} />
          <Route path="/blog/nist-ai-rmf-practical-guide" element={<BlogNISTAIRMF/>} />
          <Route path="/blog/secure-developer-ai" element={<BlogSecureDeveloperAI/>} />
          <Route path="/blog/what-is-ai-security-governance" element={<BlogAISecurityGovernance/>} />
          <Route path="/blog/oracle-to-postgresql-migration-guide" element={<BlogOracleToPostgreSQL/>} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
